























































































































































































/** @format */

import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import BdSwitch from '@/components/bd-switch';
import { IOnTimesForm, onTimesFormDefault } from './type';

Vue.filter('filterIndex', (val: number) => {
  return `${val < 9 ? '0' + (val + 1) : 1 + val}<=`;
});

@Component({
  components: { BdSwitch },
  methods: {
    moment
  }
})
export default class ByTimesRule extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  datePattern!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop()
  onTimesForm!: IOnTimesForm;

  // 分次计费111
  addonTimes() {
    try {
      if (
        this.onTimesForm &&
        this.onTimesForm.limitMoneyOfDefines.length > 0 &&
        this.onTimesForm.limitMoneyOfDefines[this.onTimesForm.limitMoneyOfDefines.length - 1].limitTime !== 0 &&
        this.onTimesForm.limitMoneyOfDefines[this.onTimesForm.limitMoneyOfDefines.length - 1].money !== 0
      ) {
        this.onTimesForm.limitMoneyOfDefines.push({ limitTime: 0, money: 0 });
      } else {
        return this.$message.warning('请填写完整');
      }
    } catch (e) {
      console.log(e);
    }
  }
  delonTimes(index: number) {
    try {
      if (this.onTimesForm && this.onTimesForm.limitMoneyOfDefines.length > 1) {
        this.onTimesForm.limitMoneyOfDefines.splice(index, 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
}
